export const AddUserAuth = (user) => {
    return {
      type: 'ADD_USER_AUTH',
      payload: user,
    };
  };
  
  export const RemoveUserAuth = {
    type: 'REMOVE_USER_AUTH',
  };